//当前路由模块公用方法

import Config from '@/config';


// eslint-disable-next-line import/no-anonymous-default-export
export default {

    //获取当前选择左测树参数
    getParams(props, nextProps){
        const { orgBreadCrumbs } = nextProps ? nextProps : props;
        const { device } = orgBreadCrumbs;
        let type;
        if(device?.type === Config.nodeType['POINT']) type = 1;
        if(device?.type === Config.nodeType['GATEWAY']) type = 2;
        if(device?.type === Config.nodeType['DEVICE'] || device.type === Config.nodeType['CHILD_DEVICE']) type = 3;
        return {
            type,
            id: type === 1 ? device.id : device?.extraInformation?.equipmentId
        };
    },

    //是否是采集点
    isPoint(orgBreadCrumbs){
        const {type} =  (orgBreadCrumbs && orgBreadCrumbs?.device) || {};
        return type === Config.nodeType['POINT'];
    },

    //是否是采集点
    isGateway(orgBreadCrumbs){
        const {type} =  (orgBreadCrumbs && orgBreadCrumbs?.device) || {};
        return type === Config.nodeType['GATEWAY'];
    },
    
}